import React from 'react';
import { Link } from 'react-router-dom';
import { RibbonNav } from '../components/ribbon/RibbonNav';
import { RibbonHero } from '../components/ribbon/RibbonHero';
import { RibbonMarquee } from '../components/ribbon/RibbonMarquee';
import { RibbonWhy } from '../components/ribbon/RibbonWhy';
import { RibbonSteps } from '../components/ribbon/RibbonSteps';
import { RibbonShop } from '../components/ribbon/RibbonShop';
import { RibbonSpecs } from '../components/ribbon/RibbonSpecs';
import { RibbonFAQ } from '../components/ribbon/RibbonFAQ';
import { RibbonSignup } from '../components/ribbon/RibbonSignup';
import { WIDE_COLORS, NARROW_COLORS } from '../data/ribbonData';

export default function NativeRibbon() {
  return (
    <div className="min-h-screen rb-body overflow-x-clip" data-testid="native-ribbon-page">
      <RibbonNav />
      <RibbonHero />
      <RibbonMarquee />
      <RibbonWhy />
      <RibbonSteps />
      <RibbonShop id="shop-1-5" size='1.5"' title="Bold by design." colors={WIDE_COLORS}
        blurb="Our statement width. Made for ribbon skirts, ribbon shirts, regalia panels and any piece that deserves to be seen."
        perks={['10 yards per roll', 'Satin polyester', 'White & black prints']} />
      <div className="max-w-7xl mx-auto px-5 sm:px-8"><div className="rb-line" /></div>
      <RibbonShop id="shop-5-8" size='5/8"' title="Every detail matters." colors={NARROW_COLORS} reverse
        blurb="Our fine width. Perfect for trims, hair ties, accessories and layering over the 1.5-inch ribbon for added depth."
        perks={['10 yards per roll', 'Satin polyester', 'White & black prints']} />
      <RibbonSpecs />
      <RibbonFAQ />
      <RibbonSignup />
      <footer className="border-t border-[#ff6a00]/30 bg-black/60 backdrop-blur-xl py-10" data-testid="ribbon-footer">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row gap-4 justify-between items-center text-sm text-white/60">
          <p className="rb-head text-lg rb-neon text-center">Finest Feathers — we shine better when we shine together.</p>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-[#ff9a3c]">Home</Link>
            <Link to="/zen-tshirts" className="hover:text-[#ff9a3c]">Zen's T-Shirts</Link>
            <a href="https://shop.finestfeathers.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#ff9a3c]">Shop</a>
          </div>
          <p>© 2026 Finest Feathers</p>
        </div>
      </footer>
    </div>
  );
}
